import React from 'react';
import {
  AutocompleteInput,
  ChipField,
  Datagrid,
  DateField,
  ImageField,
  List,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  Show,
  Tab,
  TabbedShowLayout,
  TextField,
  TextInput,
  UrlField,
  BulkDeleteButton
} from 'react-admin';
import DateFnsUtils from "@date-io/date-fns";
import { DateInput } from "react-admin-date-inputs2";

import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import format from "date-fns/format";
import { GroupList } from "./groups";
import { Paper } from "@material-ui/core";
import Button from '@material-ui/core/Button';

import { gql, useMutation } from '@apollo/react-hooks';
 
export const nameLikeSearch = (n) => {
  if (n && n.length >= 2) {
    return {
      name__like: n,
    }
  }
}
const dateParser = (date) => format(new Date(date), 'yyyy-MM');


const drawingsFilters = [
  <NumberInput source="id" label="ID" alwaysOn/>,
  <ReferenceInput label="Project" source="project_id" reference="Project" filterToQuery={nameLikeSearch} alwaysOn>
    <AutocompleteInput source="name"/>
  </ReferenceInput>,
  <TextInput source="display_name__like" label="Name" alwaysOn/>,
  <MuiPickersUtilsProvider utils={DateFnsUtils} label="Created At" source="created_at__like" alwaysOn>
    <DateInput
      source="created_at__like"
      type="date"
      label="Created At"
      openTo="year"
      parse={dateParser}
      options={{
        dateFormat: "yyyy-MM",
        views: ["year", "month"],
        disableFuture: true,
      }}
    />
  </MuiPickersUtilsProvider>,
  <MuiPickersUtilsProvider utils={DateFnsUtils} label="Updated At" source="updated_at__like" alwaysOn>
    <DateInput
      source="updated_at__like"
      type="date"
      label="Created At"
      openTo="year"
      parse={dateParser}
      options={{
        dateFormat: "yyyy-MM",
        views: ["year", "month"],
        disableFuture: true,
      }}
    />
  </MuiPickersUtilsProvider>,
];

const CONVERT_TO_GREYSCALE = gql`
  mutation convertToGreyScale($filter: DrawingFilter!) {
    convertToGreyScale(filter: $filter) {
      id
    }
  }
`;

const ConvertDrawingToGreyscale = ({ selectedIds, filterValues, ...rest }) => {
  const [convertToGreyScale] = useMutation(CONVERT_TO_GREYSCALE, {
    variables: {
      filter: { ids: selectedIds }
    }
  });
  
  function handleClick() {
    const convert = window.confirm('Convert to greyscale?')
    if (convert) {
      convertToGreyScale();
      window.location.reload();
    }
  }

  return (
    <Button 
      onClick={handleClick}
      variant="contained"
      size="small"
      color="primary"
      style={{ marginRight: "8px" }}
    >
      Convert to greyscale
    </Button>
  )
};

const DrawingBulkActionButtons = props => {
  return (
    <>
      <ConvertDrawingToGreyscale { ...props }/>
      <BulkDeleteButton {...props} />
    </>
  );
};

export const DrawingsList = props => (
  <List {...props} bulkActionButtons={<DrawingBulkActionButtons />} filters={drawingsFilters}>
    <Datagrid rowClick="show">
      <TextField source="id"/>
      <TextField source="display_name" label="name"/>
      <ReferenceField label="Project" reference="Project" source="project.id" link={false} sortable={false}>
        <ChipField source="name"/>
      </ReferenceField>
      <DateField source="created_at"/>
      <DateField source="updated_at"/>
      <ImageField source="url" label="image" sortable={false}/>
      <UrlField source="url" sortable={false}/>
      <UrlField source="original_file_url" sortable={false}/>
    </Datagrid>
  </List>
);


const DrawingsGroupList = props => {
  if (!props.record.groupsIds || props.record.groupsIds.length === 0) {
    return null
  }
  return (
    <Paper>
      <GroupList {...props} basePath="/Group" resource="Group" filter={{ ids: props.record.groupsIds }}/>
    </Paper>)
}
export const DrawingsView = props => {
  return (
    <Show {...props}>
      <TabbedShowLayout syncWithLocation={false}>
        <Tab label="Summary">
          <TextField source="id"/>
          <TextField source="display_name" label="name"/>
          <ReferenceField label="Project" reference="Project" source="project.id" link={false} sortable={false}>
            <ChipField source="name"/>
          </ReferenceField>
          <DateField source="created_at"/>
          <DateField source="updated_at"/>
          <ImageField source="url" label="image" sortable={false}/>
          <UrlField source="url" sortable={false}/>
          <UrlField source="original_file_url" sortable={false}/>
        </Tab>
        <Tab label="Groups">
          <DrawingsGroupList/>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};
